// // src/CouponRedemption.js
// import React, { useEffect, useState } from "react";
// import { Paper, Button, Box, Typography, TextField } from "@mui/material";
// import styled, { keyframes } from "styled-components";
// import ScratchCard from "./scratchcard";

// // Fireworks Animation Keyframes (Corrected)
// const fireworks = keyframes`
//   0% { transform: scale(0.5); opacity: 1; }
//   50% { transform: scale(1.5); opacity: 0.8; }
//   100% { transform: scale(2); opacity: 0; }
// `;

// const borderAnimation = keyframes`
//   0% { border-color: cyan; }
//   50% { border-color: magenta; }
//   100% { border-color: cyan; }
// `;

// // Styled Components
// const Background = styled(Box)`
//   height: 100vh;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background: radial-gradient(circle, rgba(0, 0, 0, 0.9), rgba(10, 10, 30, 1));
//   overflow: hidden;
//   position: relative;
//   flex-direction: column;
//   color: white;
// `;

// const FireworksContainer = styled.div`
//   position: absolute;
//   top: ${(props) => props.top || "50%"};
//   left: ${(props) => props.left || "50%"};
//   width: 20px;
//   height: 20px;
//   background: radial-gradient(circle, yellow, red);
//   border-radius: 50%;
//   animation: ${fireworks} 1s ease-out forwards;
// `;

// const FormContainer = styled(Box)`
//   width: 400px;
//   padding: 20px;
//   border-radius: 15px;
//   background: rgba(255, 255, 255, 0.1);
//   backdrop-filter: blur(10px);
//   border: 4px solid cyan;
//   animation: ${borderAnimation} 5s infinite linear;
//   text-align: center;
// `;

// const AnimatedTextField = styled(TextField)`
//   & .MuiOutlinedInput-root {
//     & fieldset {
//       border-width: 2px;
//       border-color: cyan;
//       animation: ${borderAnimation} 5s infinite linear;
//     }
//     &:hover fieldset {
//       border-color: magenta;
//     }
//     &.Mui-focused fieldset {
//       border-color: lime;
//     }
//   }
// `;

// const CouponRedemption = () => {
//   const [coupon, setCoupon] = useState(null);
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [registrationData, setRegistrationData] = useState({
//     username: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//   });
//   const [registrationMessage, setRegistrationMessage] = useState("");
//   const [fireworksArray, setFireworksArray] = useState([]);
//   const [scratched, setScratched] = useState(false);
//   const [showForm, setShowForm] = useState(false);
//   const [isRedeemed, setIsRedeemed] = useState(false);

//   // Optionally log the scan when the page loads (without user info)
//   const logScan = async (coupon_code) => {
//     const payload = {
//       coupon_code,
//       user_id: null, // Not logged in yet
//       ip_address: "client-ip-placeholder", // Client cannot reliably know its public IP; the backend can capture this.
//       user_agent: navigator.userAgent,
//     };
//     try {
//       await fetch(`${process.env.REACT_APP_API_URL}/api/log-scan`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });
//     } catch (err) {
//       console.error("Error logging scan:", err);
//     }
//   };

//   // Extract coupon code from URL and fetch coupon details
//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const coupon_code = params.get("coupon_code");
//     if (coupon_code) {
//       logScan(coupon_code);
//       fetchCouponDetails(coupon_code);
//     } else {
//       setError("No coupon code provided in the URL");
//       setLoading(false);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const fetchCouponDetails = async (coupon_code) => {
//     try {
//       setLoading(true);
//       setError(null);
//       setScratched(false);
//       setShowForm(false);

//       console.log("Fetching coupon:", coupon_code);

//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/api/coupon?coupon_code=${coupon_code}`
//       );

//       if (!response.ok) {
//         throw new Error("Coupon not found or error fetching coupon details.");
//       }

//       const data = await response.json();
//       console.log("Coupon Data:", data);

//       // ✅ Check if status is "used" (meaning it's redeemed)
//       if (data.status === "used") {
//         console.log("❌ Coupon is already redeemed! Blocking scratch...");
//         setIsRedeemed(true);
//         setCoupon(null);
//         setError("This coupon has already been redeemed.");
//         return;
//       }

//       console.log("✅ Coupon is valid. Allow scratch.");
//       setIsRedeemed(false);
//       setCoupon(data);

//       if (data.gift_name) {
//         generateFireworks();
//       }
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const generateFireworks = () => {
//     const fireworksData = Array.from({ length: 10 }).map(() => ({
//       id: Math.random(),
//       top: `${Math.random() * 80 + 10}%`,
//       left: `${Math.random() * 80 + 10}%`,
//     }));
//     setFireworksArray(fireworksData);
//   };

//   const handleInputChange = (e) => {
//     setRegistrationData({
//       ...registrationData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleRegistration = async (e) => {
//     e.preventDefault();
//     // Check password match
//     if (registrationData.password !== registrationData.confirmPassword) {
//       setRegistrationMessage("Passwords do not match");
//       return;
//     }
//     if (!coupon) {
//       setRegistrationMessage("Invalid coupon.");
//       return;
//     }
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/api/redeem`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             coupon_code: coupon.coupon_code,
//             username: registrationData.username,
//             email: registrationData.email,
//             phone: registrationData.phone,
//             password: registrationData.password,
//           }),
//         }
//       );
//       const data = await response.json();
//       if (!response.ok) {
//         throw new Error(
//           data.error || "Error during registration/redeeming coupon"
//         );
//       }
//       setRegistrationMessage(data.message);
//     } catch (err) {
//       setRegistrationMessage(err.message);
//     }
//   };

//   if (loading) return <Background>Loading...</Background>;
//   if (error) return <Background>{error}</Background>;
//   if (!coupon) return <Background>No coupon details found.</Background>;

//   return (
//     <Background>
//       {coupon.gift_name &&
//         fireworksArray.map((fw) => (
//           <FireworksContainer key={fw.id} top={fw.top} left={fw.left} />
//         ))}
//       <FormContainer>
//         {isRedeemed ? (
//           <Typography variant="h6" color="error">
//             This coupon has already been redeemed.
//           </Typography>
//         ) : !scratched ? ( // Show ScratchCard only if not scratched
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//             }}
//           >
//             <ScratchCard
//               onScratchComplete={() => {
//                 console.log("Scratch attempt - isRedeemed:", isRedeemed);

//                 if (isRedeemed) {
//                   console.log(
//                     "❌ Scratch blocked - coupon is already redeemed."
//                   );
//                   return;
//                 }

//                 console.log("✅ Scratch completed!");
//                 setScratched(true);
//               }}
//             />
//           </div>
//         ) : coupon.gift_name ? (
//           !showForm ? (
//             <>
//               <Typography variant="h4">🎉 Congratulations! 🎉</Typography>
//               <Typography variant="h6">
//                 You won: {coupon.gift_name} 🎁
//               </Typography>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={() => setShowForm(true)} // Show form when clicked
//               >
//                 Redeem Now
//               </Button>
//             </>
//           ) : (
//             <>
//               <Paper
//                 elevation={6}
//                 sx={{
//                   padding: 4,
//                   maxWidth: 500,
//                   mx: "auto",
//                   mt: 6,
//                   borderRadius: 3,
//                   boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
//                 }}
//               >
//                 <Typography
//                   variant="h4"
//                   fontWeight="bold"
//                   textAlign="center"
//                   gutterBottom
//                   sx={{ color: "#1976d2" }}
//                 >
//                   🎁 Register & Claim Your Gift
//                 </Typography>

//                 <Typography
//                   variant="subtitle1"
//                   textAlign="center"
//                   mb={2}
//                   color="text.secondary"
//                 >
//                   Fill in your details to redeem your exclusive reward!
//                 </Typography>

//                 <form onSubmit={handleRegistration}>
//                   <Box display="flex" flexDirection="column" gap={2}>
//                     <TextField
//                       fullWidth
//                       name="username"
//                       label="Full Name"
//                       variant="outlined"
//                       onChange={handleInputChange}
//                       required
//                       sx={{ backgroundColor: "#f9f9f9", borderRadius: 1 }}
//                     />
//                     <TextField
//                       fullWidth
//                       name="email"
//                       label="Email Address"
//                       type="email"
//                       variant="outlined"
//                       onChange={handleInputChange}
//                       required
//                       sx={{ backgroundColor: "#f9f9f9", borderRadius: 1 }}
//                     />
//                     <TextField
//                       fullWidth
//                       name="phone"
//                       label="Phone Number"
//                       variant="outlined"
//                       onChange={handleInputChange}
//                       sx={{ backgroundColor: "#f9f9f9", borderRadius: 1 }}
//                     />
//                     <TextField
//                       fullWidth
//                       name="password"
//                       label="Create Password"
//                       type="password"
//                       variant="outlined"
//                       onChange={handleInputChange}
//                       required
//                       sx={{ backgroundColor: "#f9f9f9", borderRadius: 1 }}
//                     />
//                     <TextField
//                       fullWidth
//                       name="confirmPassword"
//                       label="Confirm Password"
//                       type="password"
//                       variant="outlined"
//                       onChange={handleInputChange}
//                       required
//                       sx={{ backgroundColor: "#f9f9f9", borderRadius: 1 }}
//                     />
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       type="submit"
//                       size="large"
//                       fullWidth
//                       sx={{
//                         borderRadius: 2,
//                         fontSize: "1rem",
//                         fontWeight: "bold",
//                         padding: "10px",
//                         background:
//                           "linear-gradient(135deg, #1976d2 30%, #42a5f5 90%)",
//                       }}
//                     >
//                       🎉 Redeem My Gift
//                     </Button>
//                   </Box>
//                 </form>

//                 {registrationMessage && (
//                   <Typography color="error" textAlign="center" mt={2}>
//                     {registrationMessage}
//                   </Typography>
//                 )}
//               </Paper>
//             </>
//           )
//         ) : (
//           <Typography variant="h4">😞 Better Luck Next Time! 😞</Typography>
//         )}
//       </FormContainer>
//     </Background>
//   );
// };

// export default CouponRedemption;
// {
//   /* );
// };

//               <form onSubmit={handleRegistration}>
//                 <AnimatedTextField
//                   fullWidth
//                   name="username"
//                   label="Username"
//                   onChange={handleInputChange}
//                   required
//                   margin="dense"
//                 />
//                 <AnimatedTextField
//                   fullWidth
//                   name="email"
//                   label="Email"
//                   type="email"
//                   onChange={handleInputChange}
//                   required
//                   margin="dense"
//                 />
//                 <AnimatedTextField
//                   fullWidth
//                   name="phone"
//                   label="Phone"
//                   onChange={handleInputChange}
//                   margin="dense"
//                 />
//                 <AnimatedTextField
//                   fullWidth
//                   name="password"
//                   label="Password"
//                   type="password"
//                   onChange={handleInputChange}
//                   required
//                   margin="dense"
//                 />
//                 <AnimatedTextField
//                   fullWidth
//                   name="confirmPassword"
//                   label="Confirm Password"
//                   type="password"
//                   onChange={handleInputChange}
//                   required
//                   margin="dense"
//                 />
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   type="submit"
//                   fullWidth
//                 >
//                   Register & Redeem
//                 </Button>
//               </form>
//               {registrationMessage && (
//                 <Typography color="error">{registrationMessage}</Typography> */

// }

import React, { useEffect, useState } from "react";
import { Paper, Button, Box, Typography, TextField } from "@mui/material";
import styled, { keyframes } from "styled-components";
import ScratchCard from "./scratchcard";
// import logo from "./fabcott.jpg";

const fireworks = keyframes`
  0% { transform: scale(0.5); opacity: 1; }
  50% { transform: scale(1.5); opacity: 0.8; }
  100% { transform: scale(2); opacity: 0; }
`;

const borderAnimation = keyframes`
  0% { border-color: yellow; }
  50% { border-color: yellow; }
  100% { border-color: yellow; }
`;

// Styled Components
const Background = styled(Box)`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, skyblue, skyblue);
  overflow: hidden;
  position: relative;
  flex-direction: column;
  color: black;
  padding: 15px;
  text-align: center;
  @media (max-width: 600px) {
    justify-content: center;
    align-items: center;
  }
`;

const FireworksContainer = styled.div`
  position: absolute;
  top: ${(props) => props.top || "50%"};
  left: ${(props) => props.left || "50%"};
  width: 15px;
  height: 15px;
  background: radial-gradient(circle, yellow, red);
  border-radius: 50%;
  animation: ${fireworks} 1s ease-out forwards;
`;

const FormContainer = styled(Box)`
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0;
  border-radius: 6px;
  background: yellow;
  backdrop-filter: blur(12px);
  border: 3px solid cyan;
  animation: ${borderAnimation} 3s infinite alternate;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
height: auto; 
`;

// const AnimatedTextField = styled(TextField)`
//   & .MuiOutlinedInput-root {
//     & fieldset {
//       border-width: 2px;
//       border-color: cyan;
//       animation: ${borderAnimation} 3s infinite alternate;
//     }
//     &:hover fieldset {
//       border-color: magenta;
//     }
//     &.Mui-focused fieldset {
//       border-color: lime;
//     }
//   }
// `;

const CouponRedemption = () => {
  const [coupon, setCoupon] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  // Updated registration fields to match the backend schema (removed password fields)
  const [registrationData, setRegistrationData] = useState({
    phone: "",
    name: "",
    storeName: "",
    address: "",
    pincode: "",
    state: "",
  });
  const [registrationMessage, setRegistrationMessage] = useState("");
  const [fireworksArray, setFireworksArray] = useState([]);
  const [scratched, setScratched] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [isRedeemed, setIsRedeemed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  // Optionally log the scan when the page loads
  const logScan = async (coupon_code) => {
    const payload = {
      coupon_code,
      user_id: null, // Not logged in yet
      ip_address: "client-ip-placeholder", // Backend will capture the real IP
      user_agent: navigator.userAgent,
    };
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/api/log-scan`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      console.error("Error logging scan:", err);
    }
  };

  // Extract coupon code from URL and fetch coupon details
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const coupon_code = params.get("coupon_code");
    if (coupon_code) {
      logScan(coupon_code);
      fetchCouponDetails(coupon_code);
    } else {
      setError("No coupon code provided in the URL");
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCouponDetails = async (coupon_code) => {
    try {
      setLoading(true);
      setError(null);
      setScratched(false);
      setShowForm(false);

      console.log("Fetching coupon:", coupon_code);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/coupon?coupon_code=${coupon_code}`
      );

      if (!response.ok) {
        throw new Error("Coupon not found or error fetching coupon details.");
      }

      const data = await response.json();
      console.log("Coupon Data:", data);

      // If coupon status is "used", mark it as redeemed
      if (data.status === "used") {
        console.log("Coupon is already redeemed.");
        setIsRedeemed(true);
        setCoupon(null);
        setError("This coupon has already been redeemed.");
        return;
      }

      setIsRedeemed(false);
      setCoupon(data);

      if (data.gift_name) {
        generateFireworks();
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const generateFireworks = () => {
    const fireworksData = Array.from({ length: 10 }).map(() => ({
      id: Math.random(),
      top: `${Math.random() * 80 + 10}%`,
      left: `${Math.random() * 80 + 10}%`,
    }));
    setFireworksArray(fireworksData);
  };

  // const handleInputChange = async (e) => {
  //   let { name, value } = e.target;

  //   if (name === "phone") {
  //     value = value.replace(/\D/g, "");
  //     if (value.startsWith("0")) {
  //       value = value.substring(1);
  //     }
  //     if (value.length > 10) {
  //       value = value.slice(0, 10);
  //     }
  //     if (value.length === 10) {
  //       value = `91${value}`;
  //     }

  //     setRegistrationData((prevData) => ({
  //       ...prevData,
  //       [name]: value,
  //     }));

  //     if (value.length === 12) {
  //       fetchUserData(value);
  //     }
  //   } else {
  //     setRegistrationData((prevData) => ({
  //       ...prevData,
  //       [name]: value,
  //     }));
  //   }
  // };
  // const fetchUserData = async (phone) => {
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}/api/user?phone=${phone}`
  //     );

  //     if (!response.ok) {
  //       throw new Error("User not found.");
  //     }

  //     const userData = await response.json();

  //     setRegistrationData((prevData) => ({
  //       ...prevData,
  //       ...userData,
  //       phone,
  //     }));

  //     console.log("User data auto-filled:", userData);
  //   } catch (err) {
  //     console.error("Error fetching user data:", err);
  //   }
  // };
  const handleInputChange = async (e) => {
    let { name, value } = e.target;

    if (name === "phone") {
      value = value.replace(/\D/g, ""); // Remove non-numeric characters

      // Remove leading 91 if present (for input field display)
      if (value.startsWith("91") && value.length === 12) {
        value = value.slice(2);
      }

      if (value.startsWith("0")) {
        value = value.substring(1); // Remove leading 0
      }

      if (value.length > 10) {
        value = value.slice(0, 10); // Keep max 10 digits
      }

      setRegistrationData((prevData) => ({
        ...prevData,
        phone: value, // Store only 10-digit number in state
      }));

      if (value.length === 10) {
        fetchUserData(`91${value}`); // Send 12-digit format to backend
      }
    } else {
      setRegistrationData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const fetchUserData = async (phone) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/user?phone=${phone}` // Send full 91xxxxxxxxxx format
      );

      if (!response.ok) {
        throw new Error("User not found.");
      }

      const userData = await response.json();

      setRegistrationData((prevData) => ({
        ...prevData,
        ...userData,
        phone: userData.phone.startsWith("91")
          ? userData.phone.slice(2)
          : userData.phone, // Show 10 digits in input
        name: userData.name || prevData.name,
        storeName: userData.store_name || prevData.storeName,
        address: userData.address || prevData.address,
        pincode: userData.pincode || prevData.pincode,
        state: userData.state || prevData.state,
      }));

      console.log("User data auto-filled:", userData);
    } catch (err) {
      console.error("Error fetching user data:", err);
    }
  };
  useEffect(() => {
    console.log("Updated showThankYou:", showThankYou);
  }, [showThankYou]);
  const handleRegistration = async (e) => {
    e.preventDefault();

    if (!coupon) {
      setRegistrationMessage("Invalid coupon.");
      return;
    }
    if (isSubmitting) return;

    setIsSubmitting(true);
    let formattedPhone = registrationData.phone;
    if (formattedPhone.length === 10) {
      formattedPhone = `91${formattedPhone}`;
    }
    const payload = {
      coupon_code: coupon.coupon_code,
      ...registrationData,
      phone: formattedPhone,
    };

    console.log("🔹 Sending Registration Data:", payload);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/redeem`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.error || "Error during registration/redeeming coupon"
        );
      }

      setRegistrationMessage(data.message);
      setShowForm(false);
      setShowThankYou(true);
    } catch (err) {
      setRegistrationMessage(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) return <Background>Loading...</Background>;
  if (error) return <Background>{error}</Background>;
  if (!coupon) return <Background>No coupon details found.</Background>;

  return (
    <Background>
      {coupon.gift_name &&
        fireworksArray.map((fw) => (
          <FireworksContainer key={fw.id} top={fw.top} left={fw.left} />
        ))}
      {/* {!scratched && !isRedeemed && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ marginBottom: -6, paddingY: 5, marginTop: -20 }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{
              width: 200,
              height: 200,
              borderRadius: "50%",
              objectFit: "cover",
              marginRight: 10,
            }}
          />
        </Box>
      )} */}

      <FormContainer>
        {showThankYou ? (
          <Typography
            variant="h5"
            color="success"
            textAlign="center"
            sx={{ marginTop: 1, marginBottom: 2 }}
          >
            🎉 Thank you!
            <br />
            Your reward has been successfully redeemed and will be delivered
            within 15 days !!
          </Typography>
        ) : isRedeemed ? (
          <Typography variant="h6" color="error" sx={{ paddingY: 3 }}>
            This coupon has already been redeemed.
          </Typography>
        ) : !scratched ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ScratchCard
              onScratchComplete={() => {
                if (isRedeemed) {
                  console.log("Scratch blocked - coupon is already redeemed.");
                  return;
                }
                console.log("Scratch completed!");
                setScratched(true);
              }}
            />
          </div>
        ) : coupon.gift_name ? (
          !showForm ? (
            <>
              <br></br>
              <Typography variant="h4">Congratulations!</Typography>
              <Typography variant="h5">You won: {coupon.gift_name}</Typography>
              <br></br>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setShowForm(true)}
              >
                Redeem Now
              </Button>

              <br></br>
            </>
          ) : (
            <>
              <Paper
                elevation={6}
                sx={{
                  padding: 4,
                  maxWidth: 500,
                  mx: "auto",
                  mt: 0,
                  borderRadius: 3,
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                }}
              >
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  textAlign="center"
                  gutterBottom
                  sx={{ color: "#1976d2" }}
                >
                  🎉Congratulations!
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  textAlign="center"
                  gutterBottom
                  sx={{ color: "#1976d2" }}
                >
                  You won: {coupon.gift_name} 🎁
                </Typography>
                <Typography
                  variant="subtitle1"
                  textAlign="center"
                  mb={2}
                  color="text.secondary"
                >
                  Fill in your details to redeem your exclusive reward!
                </Typography>
                <form onSubmit={handleRegistration}>
                  <Box display="flex" flexDirection="column" gap={2}>
                    <TextField
                      fullWidth
                      name="phone"
                      label="Phone Number"
                      variant="outlined"
                      value={
                        registrationData.phone?.startsWith("91")
                          ? registrationData.phone.slice(2)
                          : registrationData.phone || ""
                      }
                      onChange={handleInputChange}
                      required
                      inputProps={{
                        maxLength: 10,
                        pattern: "[1-9][0-9]{9}",
                      }}
                      sx={{ backgroundColor: "#f9f9f9", borderRadius: 1 }}
                    />

                    <TextField
                      fullWidth
                      name="name"
                      label="Full Name"
                      variant="outlined"
                      value={registrationData.name || ""}
                      onChange={handleInputChange}
                      required
                      sx={{ backgroundColor: "#f9f9f9", borderRadius: 1 }}
                    />
                    {/* <TextField
                      fullWidth
                      name="email"
                      label="Email Address"
                      type="email"
                      variant="outlined"
                      onChange={handleInputChange}
                      required
                      sx={{ backgroundColor: "#f9f9f9", borderRadius: 1 }}
                    /> */}

                    <TextField
                      fullWidth
                      name="storeName"
                      label="Store Name"
                      variant="outlined"
                      value={registrationData.storeName || ""}
                      onChange={handleInputChange}
                      required
                      sx={{ backgroundColor: "#f9f9f9", borderRadius: 1 }}
                    />

                    <TextField
                      fullWidth
                      name="address"
                      label="Address For Gift"
                      variant="outlined"
                      value={registrationData.address || ""}
                      onChange={handleInputChange}
                      required
                      sx={{ backgroundColor: "#f9f9f9", borderRadius: 1 }}
                    />

                    <TextField
                      fullWidth
                      name="pincode"
                      label="Pincode"
                      variant="outlined"
                      value={registrationData.pincode || ""}
                      onChange={handleInputChange}
                      required
                      sx={{ backgroundColor: "#f9f9f9", borderRadius: 1 }}
                    />

                    <TextField
                      fullWidth
                      name="state"
                      label="State"
                      variant="outlined"
                      value={registrationData.state || ""}
                      onChange={handleInputChange}
                      required
                      sx={{ backgroundColor: "#f9f9f9", borderRadius: 1 }}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      size="large"
                      fullWidth
                      disabled={isSubmitting}
                      sx={{
                        borderRadius: 2,
                        fontSize: "1rem",
                        fontWeight: "bold",
                        padding: "10px",
                        background: isSubmitting
                          ? "gray"
                          : "linear-gradient(135deg, #1976d2 30%, #42a5f5 90%)",
                      }}
                    >
                      🎉 {isSubmitting ? "Processing..." : "Redeem My Gift"}
                    </Button>
                  </Box>
                </form>
                {registrationMessage && (
                  <Typography color="error" textAlign="center" mt={2}>
                    {registrationMessage}
                  </Typography>
                )}
              </Paper>
            </>
          )
        ) : (
          // : showThankYou ? (
          //   <Typography
          //     variant="h4"
          //     color="success"
          //     textAlign="center"
          //     sx={{ marginTop: 3 }}
          //   >
          //     🎉 Thank you! Your reward has been successfully redeemed. 🎁
          //   </Typography>
          // )
          <Typography variant="h4" sx={{ paddingY: 3 }}>
            <div>Better Luck</div>
            <div> Next Time! 😞</div>
          </Typography>
        )}
      </FormContainer>
    </Background>
  );
};

export default CouponRedemption;
